import React from 'react';
import { Tooltip, Typography } from 'antd';

const { Text } = Typography;

// 区域颜色（与其他组件保持一致）
export const regionColors: Record<string, string> = {
  FR1: '#8BC34A',
  CDR1: '#F44336',
  FR2: '#8BC34A',
  CDR2: '#FF9800',
  FR3: '#8BC34A',
  CDR3: '#2196F3',
  FR4: '#8BC34A',
};

export interface GridItemProps {
  pos: { position: string; aa: string; region: string };
  index: number;
}

export const GridItem: React.FC<GridItemProps> = React.memo(({ pos, index }) => {
  return (
    <Tooltip key={index} title={`${pos.position} (${pos.region})`}>
      <div
        style={{
          width: 42,
          height: 50,
          border: '1px solid #f0f0f0',
          borderRadius: 4,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: `${regionColors[pos.region] || '#f0f0f0'}20`, // 20% 透明度
        }}
      >
        <Text style={{ fontWeight: 'bold', fontSize: '1.2em' }}>{pos.aa}</Text>
        <Text style={{ fontSize: '0.7em', color: '#8c8c8c' }}>{pos.position}</Text>
      </div>
    </Tooltip>
  );
});

export default GridItem;
